import { render, staticRenderFns } from "./ViewPage.vue?vue&type=template&id=000fcb07&"
import script from "./ViewPage.vue?vue&type=script&lang=js&"
export * from "./ViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports